import { render, staticRenderFns } from "./DetailCardHead.vue?vue&type=template&id=58c478d5"
import script from "./DetailCardHead.vue?vue&type=script&lang=js"
export * from "./DetailCardHead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports